import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter,Route,
  Routes } from "react-router-dom";
import About from './components/About';
import Home from './components/Home';
import Contact from './components/Contact'
import Website from './components/Website';
import Who from './components/Who';
import Gallery from './components/Gallery';
import Excellence from './components/Excellence';
import Reg from './components/Reg';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> 
     <Routes>
     <Route path='/' element={<App/>} />
     <Route path='/reg' element={<Reg/>} />
     <Route path='/excellence' element={<Excellence/>} />
     <Route path='/gallery' element={<Gallery/>} />
     <Route path='/who' element={<Who/>} />
        <Route path='/home' element={<Home/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/Website' element={<Website/>} />
        <Route path='/about ' element={<About/>} />
      </Routes>
     </BrowserRouter>
  
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
